<template>
  <div v-if="procesos.length > 0">
    <b-col
      cols="12"
      class="h5 text-azul-medio font-weight-normal px-0 text-center text-lg-left gilmer"
    >
      Procedimientos especiales de admisión
    </b-col>
    <div
      class="rounded px-3 pt-3 pb-0 text-black-50 bg-azul-claro3 mb-2"
      v-for="(proc, index) in procesos"
      :key="'datos-proc-esp-' + index"
    >
      <div
        class="gilmer text-azul font-weight-bold w-100 border-bottom border-azul-medio pb-2 mb-2"
      >
        {{ proc.nombre }}
      </div>
      <b-row class="pb-0 mb-0 text-azul">
        <b-col cols="12" lg="7" class="pb-0 mb-2 row mt-1">
          <b-col cols="6"
            >Desde: <br />
            <strong>{{ proc.fechaPostulacion }}</strong></b-col
          >
          <b-col cols="6"
            >Hasta: <br />
            <strong>{{ proc.fechaTerminoPostulacion }}</strong></b-col
          >
        </b-col>
        <b-col cols="12" lg="5" class="d-print-none text-truncate">
          Lugar: <br />
          <strong>
            {{ proc.descripcion }}
          </strong>
        </b-col>
        <!-- TODO revisar si son unicos dos casos, recibir prop que hace toggle -->
        <b-col cols="12" class="mb-3 text-justify">
          {{ proc.observaciones }}
        </b-col>
        <b-col cols="12" class="d-print-none text-center">
          <b-button
            :disabled="proc.archivo ? false : true"
            id="ver-antecedentes-proceso-especial"
            data-testid="ver-antecedentes-proceso-especial"
            class="btn-azul-oscuro text-white mt-2 mb-3 font-weight-bold px-5"
            target="_blank"
            @click="
              $gtag.event('ver-procedimiento-especial', {
                event_category: 'procedimiento-especial',
                event_label: 'ver-procedimiento-especial' + proc.nombre,
                value: ''
              })
            "
            :href="urlDocumento(proc.archivo)"
            ><FontAwesomeIcon
              icon="download"
              class="mr-2"
            />Antecedentes</b-button
          >
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faDownload);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    procesos: {
      type: Array,
      required: true
    },
    rbd: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      urlCdn: CDN,
      prefijoDocumentos: URL_DOCUMENTOS
    };
  },
  methods: {
    urlDocumento: function(documento) {
      return this.urlCdn + this.prefijoDocumentos + this.rbd + "/" + documento;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/izquierda/ProcedimientosEspeciales.vue